import React, { FC, memo } from "react";
import classes from "./SummaryAsWorker.module.scss";
import Accordion, { AccordionSlots } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Fade from "@mui/material/Fade";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { summaryByWorker } from "../../../../types/dirary";

type Props = {
  children: React.ReactNode;
  summary: summaryByWorker;
};

const SummaryAsWorker: FC<Props> = memo(({ children, summary }) => {
  const [expanded, setExpanded] = React.useState(false);
  const theme = useTheme();
  const handleNestedExpansion = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div className={classes.rootContainer}>
      <Accordion
        expanded={expanded}
        onChange={handleNestedExpansion}
        // sx={{
        //   backgroundColor: theme.palette.foreColor.light,
        // }}
        // expanded={expanded}
        // onChange={handleExpansion}
        slots={{ transition: Fade as AccordionSlots["transition"] }}
        slotProps={{ transition: { timeout: 400 } }}
        sx={{
          backgroundColor: theme.palette.foreColor.light,
          "& .MuiAccordion-region": { height: expanded ? "auto" : 0 },
          "& .MuiAccordionDetails-root": {
            display: expanded ? "block" : "none",
          },
        }}
      >
        <AccordionSummary
          expandIcon={
            expanded ? (
              <RemoveIcon
                sx={{
                  color: theme.palette.foreColor.blue,
                }}
              />
            ) : (
              <AddIcon
                sx={{
                  color: theme.palette.foreColor.blue,
                }}
              />
            )
          }
        >
          <div className={classes.summary}>
            <div>
              <p>社員番号</p>
              <p>{summary.workerId}</p>
            </div>
            <div>
              <p>氏名</p>
              <p>{summary.workerName}</p>
            </div>

            <div>
              <p>作業時間</p>
              <p>{`${
                summary.totalWorkingTimeText
              } （${summary.totalWorkingTimeByHour.toFixed(1)}）`}</p>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: theme.palette.backColor.light,
            padding: "5px 0px",
          }}
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
});

export default SummaryAsWorker;
